import { useGetApiChatCreditKeyGetValidCreditByWorkspaceOwner, useGetApiWorkspaceGet } from "@/API"
import { Alert, Breadcrumbs, Button, Center, Group, Loader, Stack, Text } from "@mantine/core"
import { IconBell, IconDatabase, IconFlask, IconInfoCircle, IconMessage, IconMessages, IconPlugConnected, IconRobot, IconSettings } from "@tabler/icons-react"
import { Link, UseMatchRouteOptions, useNavigate, useParams } from "@tanstack/react-router"
import { UseWorkspaceAuth } from "../UseWorkspaceAuth"
import { useAuthStore } from "@/Stores/AuthStore"
import { useMemo } from "react"
import { WorkspaceNoPermissionPage } from "./WorkspaceNoPermissionPage"
import { AppBreadcrumbs } from "@/Components/AppBreadcrumbs"

function WorkspaceNavigateButton(props: { match: UseMatchRouteOptions, text: string, icon: React.ReactNode }) {
    const navigate = useNavigate()

    return <Button w={200} h={200} variant="light" onClick={() => {
        navigate({ to: props.match.to, params: props.match.params })
    }}>
        <Stack align="center">
            {props.icon}
            <Text fw={600} size="xl">{props.text}</Text>
        </Stack>
    </Button>
}

export function WorkspaceItem() {
    const { workspaceId } = useParams({ from: "/workspace/$workspaceId/" })
    const navigate = useNavigate()
    const workspace = useGetApiWorkspaceGet({ id: workspaceId })
    const validCredit = useGetApiChatCreditKeyGetValidCreditByWorkspaceOwner({ workspaceId: workspaceId })
    const auth = useAuthStore()
    const isLogin = useMemo(() => {
        return !!auth.data.userName;
    }, [auth.data.userName])
    const managerAuth = UseWorkspaceAuth(workspaceId, "Manager")
    const viewerAuth = UseWorkspaceAuth(workspaceId, "Viewer")
    return <>
        <AppBreadcrumbs
            items={[
                {
                    label: '工作空間列表',
                    linkProps: { to: '/workspace' },
                },
                {
                    label: workspace.data?.data.name,
                    active: true,
                }
            ]}
        >
            {(managerAuth) &&
                <Button size="compact-sm" leftSection={<IconSettings stroke={1.5} size={20} />} onClick={() => navigate({
                    to: "/workspace/$workspaceId/settings/users", params: {
                        workspaceId: workspaceId
                    }
                })}>
                    <Text size="sm">
                        設定
                    </Text>
                </Button>
            }
        </AppBreadcrumbs>
        {viewerAuth ?
            <Stack>
                {
                    validCredit.isFetched ? <>
                        <Text>
                            剩餘有效聊天點數 : {validCredit.data?.data}
                        </Text>
                        {
                            validCredit.data?.data == 0 &&
                            <Alert variant="light" color="red" title="沒有剩餘的聊天點數，請通知工作空間擁有者儲值點數" icon={<IconInfoCircle />} />
                        }

                    </> : <Loader />
                }
                <Group justify="center" align="center" gap={50}>
                    <WorkspaceNavigateButton match={{
                        to: "/workspace/$workspaceId/embeddingCollection", params: {
                            workspaceId: workspaceId
                        }
                    }} text="資料集合" icon={<IconDatabase size={80} />} />
                    <WorkspaceNavigateButton match={{
                        to: "/workspace/$workspaceId/chatBotData", params: {
                            workspaceId: workspaceId
                        }
                    }} text="機器人設定" icon={<IconRobot size={80} />} />
                    <WorkspaceNavigateButton match={{
                        to: "/workspace/$workspaceId/botProvider", params: {
                            workspaceId: workspaceId
                        }
                    }} text="機器人串接" icon={<IconPlugConnected size={80} />} />
                    <WorkspaceNavigateButton match={{
                        to: "/workspace/$workspaceId/notificationSettings", params: {
                            workspaceId: workspaceId
                        }
                    }} text="通知設定" icon={<IconBell size={80} />} />
                    <WorkspaceNavigateButton match={{
                        to: "/workspace/$workspaceId/chatEvaluationTestSet", params: {
                            workspaceId: workspaceId
                        }
                    }} text="聊天評估" icon={<IconFlask size={80} />} />
                </Group>
            </Stack> :
            <Center h="80%" pt="lg">
                <WorkspaceNoPermissionPage workspaceId={workspaceId} status={workspace.error?.status ?? 404} />
            </Center>
        }
    </>
}